<ng-container *ngIf="!isLoading || !useSpinner">
  <oui-autocomplete
    #searchProduit
    label="Produit"
    [control]="produitControl"
    [options]="produitAutocompleteOptions"
    [allowCustomValue]="false"
    [isLoading]="isLoading"
    [displayResetButton]="true"
    class="width-100pc"></oui-autocomplete>
</ng-container>
<div class="flex-horizontal align-self-center">
  <oui-loading *ngIf="isLoading && useSpinner"></oui-loading>
</div>
